import type { FC, ReactNode } from 'react';

interface BaseLayoutProps {
  children: ReactNode;
}

/**
 * Base layout component providing dark gradient background and centered content wrapper.
 * This is the foundational layout used for pages that need the standard dark theme styling.
 */
export const BaseLayout: FC<BaseLayoutProps> = ({ children }) => (
  <div className='min-w-full bg-[linear-gradient(244deg,var(--gx-tile-light)_0%,var(--gx-main-background)_99.27%)]'>
    <div className='flex min-h-screen min-w-[300px] justify-center p-8'>{children}</div>
  </div>
);
